// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Utils-module--bx--text-truncate--end--lyBFW";
export var bxTextTruncateFront = "Utils-module--bx--text-truncate--front--vjmBy";
export var container = "Utils-module--container--nopG3";
export var hidden = "Utils-module--hidden--ktJbO";